import React, { Component } from 'react';
import { cloneDeep } from 'lodash';

import megatableService from '../megatable/megatable-service';
import { dateService } from '../../../services/date';

import StatTable from '../megatable/stat-table';
import { Loader, NoResult } from '../../misc/loader-utils';

class Minitable extends Component {
  constructor(props) {
    super(props);

    this.megatableService = megatableService;
    this.dateService = dateService;

    this.columns = [
      { label: 'Merchant Name', name: 'merchant_name', type: 'string', selected: true },
    ];
    this.staticColumns = ['merchant_name'];
    this.direction = 'desc';

    this.getColumns();
    const dateRange = this.dateService.getPresetDateRanges().thirtyDay;

    this.state = {
      stats: [],
      loading: false,
      showNoResult: false,

      page: 1,
      perPage: 500,

      params: {
        date_from: dateService.formatDate(dateRange.startDate),
        date_to: dateService.formatDate(dateRange.endDate),
        order_by: this.orderBy,
        direction: this.direction,
        networks: 'narrativ',
      },
    };
  }

  componentDidMount() {
    this.queryStats(true);
  }

  toggleSortDirection(columnName) {
    if (this.staticColumns.includes(columnName)) return;

    this.direction = this.direction === 'desc' ? 'asc' : 'desc';
    this.setState(
      {
        params: {
          ...this.state.params,
          direction: this.direction,
        },
      },
      () => {
        this.queryStats(true);
      },
    );
  }

  queryStats(resetSearch = false) {
    this.setState({ loading: true });

    if (this.props.statType === 'merchant_epc' || this.props.statType === 'merchant_clicks') {
      this.megatableService
        .getStats(
          this.props.pubId,
          this.props.statType,
          this.state.page,
          this.state.perPage,
          cloneDeep(this.state.params),
          resetSearch,
        )
        .then(({ stats }) => {
          this.setState({
            stats,
            loading: false,
            showNoResult: !stats.length,
          });
        });
    }
  }

  getColumns() {
    if (this.props.statType === 'merchant_epc') {
      this.orderBy = 'publisher_epc';
      this.columns.push({
        label: 'EPC Last 30 Days',
        name: 'publisher_epc',
        type: 'currency',
        selected: true,
      });
    } else if (this.props.statType === 'merchant_clicks') {
      this.orderBy = 'clicks';
      this.columns.push({
        label: 'Clicks Last 30 Days',
        name: 'clicks',
        type: 'number',
        selected: true,
      });
    }
  }

  render() {
    const table =
      !this.state.loading && !this.state.showNoResult ? (
        <StatTable
          stats={this.state.stats}
          columns={this.columns}
          match={this.props.match}
          sortDisabledFields={this.staticColumns}
          statType={this.props.statType}
          tableName={this.props.statType}
          sortOptions={{ column: this.orderBy, direction: this.direction }}
          showTotals={false}
          updateSortParams={this.toggleSortDirection.bind(this)}
        ></StatTable>
      ) : null;

    return (
      <div className={`minitable ${this.props.statType}`}>
        <Loader loading={this.state.loading} />
        <NoResult
          type={`minitable-${this.props.statType}`}
          noResult={!this.state.loading && this.state.showNoResult}
        />
        {table}
      </div>
    );
  }
}

export default Minitable;
